import { SkyBoxRoutesEnum } from "models/enums/apiRoutes/skyBoxApiRoutes";
import { 
    ICopyDownMetadataEventData, 
    IEventListResponseData, 
    IEventMetadata, 
    IEventMetadataForCreateZoneListingResponse,
    IEventMetadataQueryParams,
    IEventMetadataResponse,
    IEventMetadataZoneScorecardBreakdown,
    IEventMetadataZoneScorecardBreakdownQueryParams,
    IMetadataAuditData, 
    IMetadataTrendData, 
    IPendingZoneFillsListData,
    IPendingZoneFillsListQueryParams,
    IEventListQueryParams,
    IPurchaseAssignmentData,
    ISplitMetadata
} from "models/interfaces";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";

export class EventService {
    public getEventDetailsData = async (venueDetailsRequest: IEventListQueryParams) => {
        return axiosClient.get<IApiBaseResponse<IEventListResponseData>>(SkyBoxRoutesEnum.EVENT_DETAILS, {
            params: venueDetailsRequest
        })
    }

    public getEventMetadata = async (eventMetadataRequest: IEventMetadataQueryParams) => {
        return axiosClient.get<IApiBaseResponse<IEventMetadataResponse>>(SkyBoxRoutesEnum.EVENT_METADATA, {
            params: eventMetadataRequest
        })
    }

    public getEventMetadataForCreateNewZoneListing = async (eventMetadataRequest: IEventMetadataQueryParams) => {
        return axiosClient.get<IApiBaseResponse<IEventMetadataForCreateZoneListingResponse>>(SkyBoxRoutesEnum.EVENT_METADATA_FOR_NEW_ZONE_LISTING, {
            params: eventMetadataRequest
        })
    }

    public getEventMetadataZoneScorecardBreakdown = async (breakdownRequest: IEventMetadataZoneScorecardBreakdownQueryParams) => {
        return axiosClient.get<IApiBaseResponse<IEventMetadataZoneScorecardBreakdown | null>>(SkyBoxRoutesEnum.EVENT_METADATA_ZONE_SCORECARD_BREAKDOWN, {
            params: breakdownRequest
        })
    }

    public getMetadataAuditHistory = async (metadataAuditHistoryRequest: IEventMetadataQueryParams) => {
        return axiosClient.get<IApiBaseResponse<IMetadataAuditData>>(SkyBoxRoutesEnum.EVENT_METADATA_AUDIT_HISTORY, {
            params: metadataAuditHistoryRequest
        })
    }

    public getMetadataTrendData = async (metadataTrendDataRequest: IEventMetadataQueryParams) => {
        return axiosClient.get<IApiBaseResponse<IMetadataTrendData>>(SkyBoxRoutesEnum.EVENT_METADATA_TREND_DATA, {
            params: metadataTrendDataRequest
        })
    }

    public saveMetadata = async (metadataSaveRequest: IEventMetadata) => {
        return axiosClient.post<IApiBaseResponse>(SkyBoxRoutesEnum.EVENT_METADATA_SAVE, metadataSaveRequest);
    }

    public getEventsForCopyDownMetadata = async (event_id: number) => {
        const url = SkyBoxRoutesEnum.EVENT_LIST_FOR_COPY_DOWN_METADATA.replace(
            "{event_id}",
            event_id.toString()
        );
        return axiosClient.get<IApiBaseResponse<ICopyDownMetadataEventData>>(url);
    }

    public saveEventsForCopyDownMetadata = async (event_id: number, target_event_ids: number[]) => {
        const url = SkyBoxRoutesEnum.EVENT_SAVE_COPY_DOWN_METADATA.replace(
            "{event_id}",
            event_id.toString()
        );
        return axiosClient.post<IApiBaseResponse<{success_event_ids: number[] | null}>>(
            url,
            {
                target_event_ids
            }
        );
    }

    public getPendingZoneFillsListings = async (query: IPendingZoneFillsListQueryParams) => {
        return axiosClient.get<IApiBaseResponse<IPendingZoneFillsListData>>(
            SkyBoxRoutesEnum.ZONE_PENDING_ZONE_FILLS,
            {
                params: query,
            }
        );
    };

    public getPendingZoneFillsPurchaseAssignmentData = async (query: {
        purchase_line_ids: string | null;
        venue_id: number | null
    }) => {
        return axiosClient.get<IApiBaseResponse<IPurchaseAssignmentData>>(
            SkyBoxRoutesEnum.ZONE_PENDING_ZONE_FILLS_PURCHASE_ASSIGNMENT, {
                params: query
            }
        );
    }

    public postPurchaseAssignment = async (body: any) => {
        return axiosClient.post<IApiBaseResponse<any>>(
            SkyBoxRoutesEnum.ZONE_PENDING_ZONE_FILLS_SAVE_PURCHASE_ASSIGNMENT,
            body
        );
    };

    public refreshUpcomingEventsMVW = async () => {
        return axiosClient.get<IApiBaseResponse<{success: boolean}>>(SkyBoxRoutesEnum.EVENT_REFRESH_MVW);
    }

    public saveSplitMetadata = async (metadata: ISplitMetadata) => {
        return axiosClient.post<IApiBaseResponse>(SkyBoxRoutesEnum.SPLIT_METADATA, metadata);
    }

    public saveAutoListingStatus = async (
        event_id: number,
        is_auto_listing_enabled: boolean
    ) => {
        return axiosClient.patch<IApiBaseResponse<{ is_auto_listing_enabled: boolean }>>(
            SkyBoxRoutesEnum.EVENT_AUTO_LISTING,
            { event_id, is_auto_listing_enabled }
        );
    }
}
